import React, { Component } from 'react';
import { AlertTriangle } from 'lucide-react';
interface Props {
  children: React.ReactNode;
  onReset?: () => void;
}
interface State {
  hasError: boolean;
  error: Error | null;
}
export class MaternityErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
    error: null
  };
  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Surface in console for debugging
    // eslint-disable-next-line no-console
    console.error('MaternityErrorBoundary caught:', error, info);
  }
  reset = () => {
    this.setState({
      hasError: false,
      error: null
    });
    this.props.onReset?.();
  };
  render() {
    if (this.state.hasError) {
      return <div className="bg-white rounded-lg shadow-sm border border-red-200 p-8 text-center" data-id="element-92">
          <AlertTriangle className="w-12 h-12 text-red-500 mx-auto mb-3" data-id="element-93" />
          <p className="text-lg font-semibold text-gray-900 mb-1" data-id="element-94">
            This maternity file couldn't be displayed.
          </p>
          <p className="text-sm text-gray-600 mb-4" data-id="element-95">
            It may be an older record missing some fields. Try selecting it
            again — the system will fill in the missing sections automatically.
          </p>
          {this.state.error?.message && <p className="text-xs text-gray-400 mb-4 font-mono" data-id="element-96">
              {this.state.error.message}
            </p>}
          <button onClick={this.reset} className="px-4 py-2 bg-pink-600 text-white rounded hover:bg-pink-700 text-sm font-medium" data-id="element-97">
            Reload file
          </button>
        </div>;
    }
    return this.props.children;
  }
}